import { render } from "./PopupTrangThaiHang.vue?vue&type=template&id=5891c889&scoped=true"
import script from "./PopupTrangThaiHang.vue?vue&type=script&lang=js"
export * from "./PopupTrangThaiHang.vue?vue&type=script&lang=js"

import "./PopupTrangThaiHang.vue?vue&type=style&index=0&id=5891c889&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5891c889"]])

export default __exports__